/* eslint-disable no-underscore-dangle */
import type { html, LitElement } from 'lit';

import { TemplateResolver, type TemplateTheme } from '../TemplateResolver';

type Constructor<T = object> = new (...args: any[]) => T; // eslint-disable-line @typescript-eslint/no-explicit-any

export type GetTemplateFn = (...params: unknown[]) => ReturnType<typeof html>;

export declare class TemplatingMixinI {
  getTemplateFn(templateName: string) : GetTemplateFn;
  setTemplatingTheme(templateTheme : TemplateTheme) : void;
}

export const TemplatingMixin = <T extends Constructor<LitElement>, TemplatesDefinition>(
  superClass: T, theme : TemplateTheme,
  templates: TemplatesDefinition) => {
  class TemplatingMixinClass extends superClass {
    _templateResolver : TemplateResolver<unknown>;

    constructor(...params: any[]) { // eslint-disable-line
      super(params);
      this._templateResolver = TemplateResolver.getInstance(theme, templates);
    }

    // Returns a callable template function where "this" is the actual component instance.
    getTemplateFn<U extends keyof typeof templates[keyof typeof templates]>(templateName: U) {
      const templateFn = this._templateResolver.resolve(templateName);
      return templateFn.bind(this) as GetTemplateFn;
    }

    setTemplatingTheme(templateTheme : TemplateTheme) {
      TemplateResolver.clear();
      this._templateResolver = TemplateResolver.getInstance(templateTheme, templates);
    }
  }
  return TemplatingMixinClass as Constructor<TemplatingMixinI> & T;
};
